// src/ArrowLeft.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var ArrowLeft_default = createIcon({
  displayName: "ArrowLeft",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M9.65653 5C9.40066 5 9.1445 5.09942 8.9495 5.29492L3.29325 10.9512C2.90225 11.3422 2.90225 11.9752 3.29325 12.3652L8.9495 18.0215C9.3405 18.4125 9.97356 18.4125 10.3636 18.0215L10.4495 17.9355C10.8405 17.5445 10.8405 16.9115 10.4495 16.5215L6.58622 12.6582H19.6565C20.2085 12.6582 20.6565 12.2102 20.6565 11.6582C20.6565 11.1062 20.2085 10.6582 19.6565 10.6582H6.58622L10.4495 6.79492C10.8405 6.40392 10.8405 5.77086 10.4495 5.38086L10.3636 5.29492C10.1681 5.09942 9.91241 5 9.65653 5Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      })
    ]
  })
});

export {
  ArrowLeft_default
};
